import React from 'react';

import { Glossary, BoardGL } from 'common/utils/glossary';
import {
  Button,
  Message,
  Notes,
  Checkbox,
  LinkText,
  Separator,
  Spinner
} from 'common/components';
import { SubButtonType } from 'common/components/button';

interface BeforeCancelBoardProps {
  /** BeforeCancelBoardの表示有無 */
  isDisplay: boolean;
  /** 解約処理中か否か */
  isProcessing: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** "クローズボタン"の押下処理 */
  onClickClose: () => void;
  /** 解約する"の押下処理 */
  onClickCancelPurchase: () => void;
}

/**
 * 解約確認画面のPresentation Component
 */
export const BeforeCancelBoard: React.FC<BeforeCancelBoardProps> = ({
  isDisplay,
  isProcessing,
  glossary,
  onClickClose,
  onClickCancelPurchase
}) => {
  /**  チェック状態の定義と変更 */
  const [isChecked, setIsChecked] = React.useState<boolean>(false);

  /** チェックボックス変更時の処理 */
  const onChangeCheckBox = (event: any) => {
    setIsChecked(event.target.checked);
  };

  /** チェックボックスラベル押下時の処理 */
  const onClickCheckBoxLabel = () => {
    setIsChecked(!isChecked);
  };

  /** チェック状態によって購入ボタンのサブタイプを制御 */
  let subButtonType: SubButtonType = 'invalid';
  if (isChecked) {
    subButtonType = 'highPriority';
  }

  /** 表示時にチェックボックスをチェックなしにする */
  React.useEffect(() => {
    setIsChecked(false);
  }, [isDisplay]);

  const _component = (
    <div className="beforeCancelBoard" data-test="beforeCancelBoard">
      <Button
        type="toolButton"
        subType="close"
        data-test="beforeCancelBoard-toolButton"
        onClick={onClickClose}
      />
      <Message type="message" data-test="beforeCancelBoard-message">
        {glossary.glx(BoardGL.BeforeCancelBoardTitle)}
      </Message>
      <Separator type="separator" data-test="BeforeChancelBoardSeparator1" />
      <Notes
        notes={[glossary.glx(BoardGL.BeforeCancelBoardNote)]}
        data-test={`beforeCancelBoard-notes`}
      />
      <div className="beforeCancelBoard-agreement">
        <Checkbox
          id="id_1"
          value="agreement"
          checked={isChecked}
          onChange={onChangeCheckBox}
          data-test="beforeCancelBoard-checkbox"
        />
        <LinkText
          type="checkBoxLabel"
          className="agreement-label"
          onClick={onClickCheckBoxLabel}
          data-test="beforeCancelBoard-agreementLabel"
        >
          {glossary.glx(BoardGL.AgreementCheckboxLabel)}
        </LinkText>
      </div>
      <Separator type="separator" data-test="BeforeChancelBoardSeparator2" />
      <Button
        type="nextButton"
        subType={subButtonType}
        data-test="beforeCancelBoard-nextButton"
        onClick={onClickCancelPurchase}
      >
        {isProcessing ? (
          <Spinner type="button" width={22} height={22} color="#FFFFFF" />
        ) : (
          glossary.glx(BoardGL.BeforeCancelBoardExecuteCancel)
        )}
      </Button>
    </div>
  );
  return isDisplay ? _component : null;
};
